import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import React, { useEffect, useMemo, useState } from "react";
import convertToRoman from "../helpers/convertToRoman";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useMediaQuery } from "@/hooks/use-media-query";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { useSelector } from "react-redux";

const PassengerDetailsForm = () => {
  const {
    holdedFlightResponse,
    searchFilters,
  } = useSelector((state) => state.flights);


  const { control, getValues, setValue } = useFormContext();
  const { fields, } = useFieldArray({
    control,
    name: "paxDetails",
  });
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const [openDobIndex, setOpenDobIndex] = useState(null);
  const [openExpIndex, setOpenExpIndex] = useState(null);



  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };
  }, []);

  const option = useMemo(
    () => {
      return (
        searchFilters &&
          searchFilters.Countries &&
          searchFilters.Countries.length > 0 ? (
          searchFilters.Countries.map((country) => {
            return (
              <SelectItem
                value={country.CountryCode}
                key={country.CountryID}
              >
                {country.CountryName}
              </SelectItem>
            );
          })
        ) : (
          <SelectItem value="0" disabled>
            No countries
          </SelectItem>
        )
      );
    },
    [searchFilters]
  );

  return (
    fields.map((passenger, index) => {
      return <div key={passenger.id} className="p-1">
        <Card className="shadow-none">
          <CardHeader className="pt-0">
            <CardTitle className="text-lg">
              Passenger{" "}{convertToRoman(index + 1)}{"-"}({passenger.paxType})
              {/* {searchFilters &&
                searchFilters.PassengerTypes &&
                searchFilters.PassengerTypes.find(
                  (pt) => pt.Code == passenger.Code
                ).TypeName + " - "} */}

            </CardTitle>
            <CardDescription>
              Fill up the passenger detail matching your government document.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 justify-between">
              <FormField
                control={control}
                name={`paxDetails.${index}.title`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Title</FormLabel>
                    <Select
                      onValueChange={field.onChange}
                      defaultValue={field.value}
                    >
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue placeholder="Select Title" />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        <SelectItem value="Mr">Mr</SelectItem>
                        <SelectItem value="Miss">Miss</SelectItem>
                        <SelectItem value="Mrs">Mrs</SelectItem>
                      </SelectContent>
                    </Select>
                    {/* <FormDescription>
You can manage email addresses in your{" "}
<Link href="/examples/forms">email settings</Link>.
</FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={control}
                name={`paxDetails.${index}.firstName`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>First Name</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={control}
                name={`paxDetails.${index}.lastName`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Last Name</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={control}
                name={`paxDetails.${index}.contactNo`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Contact No</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={control}
                name={`paxDetails.${index}.email`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Email</FormLabel>
                    <FormControl>
                      <Input
                        type="email"
                        {...field}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={control}
                name={`paxDetails.${index}.paxType`}
                render={({ field }) => {
                  return (
                    <FormItem className={"hidden"}>
                      <FormLabel>Type</FormLabel>
                      <FormControl>
                        <Input
                          type="text"
                          value={field.value}
                          defaultValue={passenger.Code}
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  );
                }}
              />

              <FormField
                control={control}
                name={`paxDetails.${index}.dateOfBirth`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Date of birth</FormLabel>
                    {isDesktop ?
                      <Popover
                        open={openDobIndex === index}
                        onOpenChange={(open) => setOpenDobIndex(open ? index : null)}
                      >

                        <PopoverTrigger asChild>
                          <FormControl>
                            <Button
                              variant={"outline"}
                              className={cn(
                                " pl-3 text-left font-normal",
                                !field.value && "text-muted-foreground"
                              )}
                            >
                              {field.value ? (
                                format(field.value, "PPP")
                              ) : (
                                <span>Pick a date</span>
                              )}
                              <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                            </Button>
                          </FormControl>
                        </PopoverTrigger>
                        <PopoverContent className="w-auto p-0" align="start">
                          <Calendar
                            mode="single"
                            captionLayout="dropdown-buttons"
                            fromYear={new Date().getFullYear() - 100}
                            toYear={new Date().getFullYear()}
                            selected={field.value}
                            onSelect={(e) => {
                              field.onChange(e);
                              setOpenDobIndex(null);
                            }}
                            disabled={(date) =>
                              date > new Date() || date < new Date("1900-01-01")
                            }
                            initialFocus
                          />
                        </PopoverContent>
                      </Popover>
                      :
                      <Drawer open={openDobIndex === index}
                        onOpenChange={(open) => setOpenDobIndex(open ? index : null)}>
                        <DrawerTrigger asChild>
                          <FormControl>
                            <Button
                              variant={"outline"}
                              className={cn(
                                " pl-3 text-left font-normal",
                                !field.value && "text-muted-foreground"
                              )}
                            >
                              {field.value ? (
                                format(field.value, "PPP")
                              ) : (
                                <span>Pick a date</span>
                              )}
                              <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                            </Button>
                          </FormControl>
                        </DrawerTrigger>
                        <DrawerContent>
                          <Calendar
                            className="flex-1"
                            mode="single"
                            captionLayout="dropdown-buttons"
                            fromYear={new Date().getFullYear() - 100}
                            toYear={new Date().getFullYear()}
                            selected={field.value}
                            onSelect={(e) => {
                              setOpenDobIndex(null);
                              field.onChange(e);
                            }}
                            disabled={(date) =>
                              date > new Date() || date < new Date("1900-01-01")
                            }
                            initialFocus
                          />
                        </DrawerContent>
                      </Drawer>
                    }
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={control}
                name={`paxDetails.${index}.document.docType`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Document Type</FormLabel>
                    <Select
                      onValueChange={field.onChange}
                      defaultValue={field.value}
                    >
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue placeholder="Select a document Type" />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        <SelectItem value="N">None</SelectItem>
                        <SelectItem value="P">Passport</SelectItem>
                        <SelectItem value="C">Permanent Resident Card</SelectItem>
                        <SelectItem value="I">National ID Card</SelectItem>
                      </SelectContent>
                    </Select>
                    {/* <FormDescription>
You can manage email addresses in your{" "}
<Link href="/examples/forms">email settings</Link>.
</FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={control}
                name={`paxDetails.${index}.document.number`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Document No</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>

                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={control}
                name={`paxDetails.${index}.document.issueCountry`}
                render={({ field }) => (

                  <FormItem className="flex flex-col">
                    <FormLabel>Issue Country</FormLabel>
                    <Select
                      onValueChange={field.onChange}
                      value={field.value}
                      defaultValue={field.value}
                    >
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        {option}
                      </SelectContent>
                    </Select>

                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={control}
                name={`paxDetails.${index}.document.expDate`}
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Expiry Date</FormLabel>
                    <Popover open={openExpIndex === index}
                      onOpenChange={(open) => setOpenExpIndex(open ? index : null)}>
                      <PopoverTrigger asChild>
                        <FormControl>
                          <Button
                            variant={"outline"}
                            className={cn(
                              " pl-3 text-left font-normal",
                              !field.value && "text-muted-foreground"
                            )}
                          >
                            {field.value ? (
                              format(field.value, "PPP")
                            ) : (
                              <span>Pick a date</span>
                            )}
                            <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                          </Button>
                        </FormControl>
                      </PopoverTrigger>
                      <PopoverContent className="w-auto p-0" align="start">
                        <Calendar
                          mode="single"
                          captionLayout="dropdown-buttons"
                          fromYear={new Date().getFullYear()}
                          toYear={new Date().getFullYear() + 50}
                          selected={field.value}
                          onSelect={(e) => { field.onChange(e); setIsExpiryCalenderOpen(false); }}
                          disabled={(date) => date < new Date().setMonth(new Date().getMonth() + 6)}
                          initialFocus
                          defaultMonth={field.value ?? new Date().setMonth(new Date().getMonth() + 6)}
                        />
                      </PopoverContent>
                    </Popover>
                    {/* <FormDescription>
Your date of birth is used to calculate your age.
</FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />

              {/*
            #region Services
            {holdedFlightResponse.Services &&
              holdedFlightResponse.Services.length > 0 && (
                <FormField
                  control={form.control}
                  name={`paxDetails.${index}.services.0.serviceCode`}
                  render={({ field }) => (
                    <FormItem className="flex flex-col">
                      <FormLabel>Meal</FormLabel>
                      <Select
                        onValueChange={(val) => {
                          form.setValue(
                            `paxDetails.${index}.services.0`,
                            holdedFlightResponse.Services.filter(
                              (ser) => ser.ServiceCode == val
                            ).map((item) => {
                              return {
                                serviceCode: item.ServiceCode,
                                serviceType: item.ServiceType,
                              };
                            })[0]
                          );
                        }}
                        defaultValue={field.value}
                      >
                        <FormControl>
                          <SelectTrigger>
                            <SelectValue />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          {holdedFlightResponse.Services.filter(
                            (ser) => ser.ServiceType == 1
                          ).map((item) => {
                            return (
                              <SelectItem value={item.ServiceCode}>
                                {item.ServiceName}
                              </SelectItem>
                            );
                          })}
                        </SelectContent>
                      </Select>
                    
                      <FormMessage />
                    </FormItem>
                  )}
                />
              )}
            {holdedFlightResponse.Services &&
              holdedFlightResponse.Services.length > 0 && (
                <FormField
                  control={form.control}
                  name={`paxDetails.${index}.services.1.serviceCode`}
                  render={({ field }) => (
                    <FormItem className="flex flex-col">
                      <FormLabel>
                        Special Requisition{" "}
                        <span className="text-sm text-neutral-500">
                          {"(Optional)"}
                        </span>
                      </FormLabel>
                      <Select
                        onValueChange={
                          (val) => {
                            form.setValue(
                              `paxDetails.${index}.services.1`,
                              holdedFlightResponse.Services.filter(
                                (ser) => ser.ServiceCode == val
                              ).map((item) => {
                                return {
                                  serviceCode: item.ServiceCode,
                                  serviceType: item.ServiceType,
                                };
                              })[0]
                            );
                          }
                          // field.onChange
                        }
                        defaultValue={field.value}
                      >
                        <FormControl>
                          <SelectTrigger>
                            <SelectValue />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          {holdedFlightResponse.Services.filter(
                            (ser) => ser.ServiceType == 2
                          ).map((item) => {
                            return (
                              <SelectItem value={item.ServiceCode}>
                                {item.ServiceName}
                              </SelectItem>
                            );
                          })}
                        </SelectContent>
                      </Select>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              )} 
               #endregion
               */}
              {passenger.paxType == "ADT" && (
                <FormField
                  control={control}
                  name={`paxDetails.${index}.isContactPerson`}
                  render={({ field }) => (
                    <FormItem className="flex mt-2">
                      <FormControl>
                        <div className="flex items-center space-x-2">
                          <Checkbox
                            id={`contactPerson_${index}`}
                            checked={!!field.value}
                            onCheckedChange={(checked) => {
                              const isChecked = checked === true; // shadcn can pass "indeterminate"
                              if (!isChecked) {
                                // allow unchecking if you want
                                field.onChange(false);
                                return;
                              }

                              // when checking this one: uncheck all ADT passengers first
                              const pax = getValues("paxDetails") ?? [];
                              pax.forEach((p, i) => {
                                if (p?.paxType === "ADT") {
                                  setValue(`paxDetails.${i}.isContactPerson`, i === index, {
                                    shouldDirty: true,
                                    shouldTouch: true,
                                    shouldValidate: false,
                                  });
                                }
                              });
                            }}
                          />
                          <label
                            htmlFor={`contactPerson_${index}`}
                            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                          >
                            I'm Contact Person
                          </label>
                        </div>
                      </FormControl>

                      <FormMessage />
                    </FormItem>
                  )}
                />
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    })

  );
};

export default PassengerDetailsForm;
